import React$1, { useContext } from 'react';
import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import { NavigationContext } from '../../contexts/NavigationProvider/NavigationProvider.js';
import StyledMainContainer from './MainContainer.style.js';

const MainContainer = (_ref) => {
  let {
    children,
    hasAccentLine
  } = _ref,
      props = _objectWithoutProperties(_ref, ["children", "hasAccentLine"]);

  const {
    isOpen
  } = useContext(NavigationContext);
  return /*#__PURE__*/React$1.createElement(StyledMainContainer, _extends({
    navigationIsOpen: isOpen,
    hasAccentLine: hasAccentLine
  }, props), /*#__PURE__*/React$1.createElement("div", {
    className: "mainContainer__inner"
  }, children));
};

MainContainer.propTypes = {
  children: PropTypes$1.node,
  hasAccentLine: PropTypes$1.bool
};
MainContainer.defaultProps = {
  children: null,
  hasAccentLine: false
};

export default MainContainer;
